import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import 'animate.css';
import Countdown from 'react-countdown';
import maintainUtm, { generateButtonId } from '../../services/maintainUtm';
import { getCurrentPageIdWithDevice } from "../../services/maintainUtm/idPages";

import * as S from './styles';

export const compendioG = "@compendioG";

const CountdownBlack = ({ onVisibilityChange, campaign, ...props }) => {
    const location = useLocation();
    const currentPath = location.pathname;

    const [isVisible, setIsVisible] = useState(true);
    const [isAnimating, setIsAnimating] = useState(false);
    const [width, setWidth] = useState(window.innerWidth);
    const [utmUrl, setUtmUrl] = useState('');

    useEffect(() => {
        if (campaign) {
            const currentPageId = getCurrentPageIdWithDevice();
            const buttonId = generateButtonId(campaign.nome_campanha, `${currentPageId}`, `${currentPageId}-contadortopo`);
            const search = maintainUtm(buttonId);
            let url = `/planos${search}`;

            if (!url.includes('cupom=')) {
                url += `&cupom=${campaign.agro_coupon.nome_cupom}`;
            }

            setUtmUrl(url);
        }
    }, [campaign]);

    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const currentDate = new Date();
    const baseTarget = campaign?.data_final ? new Date(campaign.data_final) : new Date('2025-11-30T23:59:59');
    const targetDate = new Date(baseTarget.getTime() + 3 * 60 * 60 * 1000);

    useEffect(() => {   
        onVisibilityChange(isVisible);
    }, [isVisible, onVisibilityChange]);

    const renderer = ({ days, hours, minutes, seconds, completed }) => {
        if (completed) {
            return null;
        } else {
            return (
                <S.ContainerCountdown>
                    <S.ContainerBlock>
                        <span>{days}</span>

                        <span>dias</span>
                    </S.ContainerBlock>

                    <S.ContainerBlock>
                        <span>{hours}</span>

                        <span>horas</span>
                    </S.ContainerBlock>

                    <S.ContainerBlock>
                        <span>{minutes}</span>

                        <span>minutos</span>
                    </S.ContainerBlock>

                    <S.ContainerBlock>
                        <span>{seconds}</span>

                        <span>segundos</span>
                    </S.ContainerBlock>
                </S.ContainerCountdown>
            );
        }
    };

    const handleClick = (e) => {
        e.preventDefault();
        
        if (window.location.pathname === '/receituario-agronomico-2026') {
            const buttonId = generateButtonId(campaign?.nome_campanha, 'LPreceituario', 'contadorgrande');
            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set('button', buttonId);
            window.history.pushState({}, '', currentUrl.toString());

            window.location.href = '#teste-gratis';
        } else {
            window.location.href = utmUrl;
        }
    };

    const getUserPlan = localStorage.getItem('@plan_name');
    if (!campaign) return null;
    if (!isVisible || currentDate > targetDate) {
        return null;
    }

    if (currentPath === "/black-november-2024" || currentPath === "/receituario-agronomico-2026" || currentPath === "/receituario-agronomico-2026b" || currentPath === "/receituario-agronomico-2024") {

        const containerClass = isAnimating ? 'animate__animated animate__fadeOutUp' : '';

        if (!isVisible || currentDate <= targetDate) {
            return (
                <S.Container className={containerClass}>
                    <S.Wrapper>
                        <S.ContainerBlack>
                            <S.InformationBlack>
                                <h1>{campaign?.nome_campanha}</h1>
                                <p dangerouslySetInnerHTML={{ __html: campaign?.descricao || '' }} />
                            </S.InformationBlack>

                            <S.CountdownAndButton>
                                <Countdown date={targetDate} renderer={renderer} />

                                <a href={window.location.pathname === '/receituario-agronomico-2026' ? '#teste-gratis': utmUrl} onClick={handleClick}>
                                    <button>
                                        <p>Garantir desconto</p>
                                    </button>
                                </a>
                            </S.CountdownAndButton>
                        </S.ContainerBlack>
                    </S.Wrapper>
                </S.Container>
            );
        } else {
            return null;
        }
    }

    return null;
};

export default CountdownBlack;